(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockZusammenfassungDetails', {
            bindings: {
                angebotVm: '<abzdAngebotVm',
                options: '<abzdOptions'
            },
            templateUrl: 'bloecke/zusammenfassung/blockZusammenfassungDetails.html',
            controller: BlockZusammenfassungDetailsController,
            controllerAs: 'zusammenfassungDetailsVm'
        });

    BlockZusammenfassungDetailsController.$inject = [
        '$templateCache',
        '$window',
        '$timeout',
        '$injector',
        'lodash',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'MiscUtilsService',
        'AngebotUtilsService',
        'NavigationService',
        'HtmlUtilsService'
    ];
    function BlockZusammenfassungDetailsController($templateCache, $window, $timeout, $injector, _, AppConfig, AngebotModel, BasisAngebotService, MiscUtilsService, AngebotUtilsService, NavigationService, HtmlUtilsService) {
        var vm = this,
            AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(AngebotModel.get().angebot) + 'Service'),
            BlockArbeitgeberBerufService = $injector.has('BlockArbeitgeberBerufService') && $injector.get('BlockArbeitgeberBerufService');

        vm.$onInit = onInit;
        vm.isTemplateVorhanden = isTemplateVorhanden;
        vm.isBlockSichtbar = isBlockSichtbar;
        vm.editBlock = editBlock;
        vm.getAngebotspartnerNameAsString = getAngebotspartnerNameAsString;
        vm.getZahlweise = BasisAngebotService.getZahlweise;
        vm.isAngebotAenderbar = isAngebotAenderbar;
        vm.isTarifartAktiv = isTarifartAktiv;
        vm.getAvbVersion = getAvbVersion;
        vm.AngebotSpezifischService = AngebotSpezifischService;
        vm.getArbeitgeberBerufFlags = getArbeitgeberBerufFlags;
        vm.isGevo = isGevo;
        vm.isAngebotspartnerPrivatPerson = isAngebotspartnerPrivatPerson;

        function onInit() {
            activate();
        }

        function activate() {
            vm.angebotModel = AngebotModel.get();
            vm.options = vm.options || {};
            vm.tarifauskunftsdatumType = AppConfig.ANGEBOT.tarifauskunftsdatumType;
            vm.blaulichtVorhanden = AppConfig.ANGEBOT.blaulichtVorhanden;
            vm.isAngebotAnonym = BasisAngebotService.isAngebotAnonym(vm.angebotModel.angebot);
            vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot);

            BasisAngebotService.mapFormToServiceData(vm.angebotModel.formData, vm.angebotModel.angebot);

            vm.CONSTANTS = {
                inkassoarten: BasisAngebotService.getConstant('inkassoarten')
            };

            vm.gesamtbeitragZuZahlweise = BasisAngebotService.getGesamtbeitragZuZahlweise(vm.angebotModel.angebot, true);

            vm.angebotsgegenstaende = BasisAngebotService.getGegenstaende(vm.angebotModel.angebot, null, {
                onlyActive: true
            });

            vm.beitraegeByProduktGruppe = BasisAngebotService.getBeitraegeGroupedByProduktGruppe(vm.angebotModel.angebot, {
                onlyActive: false,
                convertToArray: false,
                type: 'ANTRAG_PRUEFEN'
            });
            vm.beitraegeByProduktGruppeArray = BasisAngebotService.getBeitraegeGroupedByProduktGruppe(vm.angebotModel.angebot, {
                onlyActive: true,
                convertToArray: true,
                type: 'ANTRAG_PRUEFEN'
            });

            if (_.isFunction(AngebotSpezifischService.korrigiereBeitraegeByProduktGruppeArray)) {
                vm.beitraegeByProduktGruppeArray = AngebotSpezifischService.korrigiereBeitraegeByProduktGruppeArray(vm.beitraegeByProduktGruppeArray);
            }

            vm.produktgruppenAktiv = BasisAngebotService.getProduktGruppen(vm.angebotModel.angebot, true);
        }
        function isTemplateVorhanden(templateUrl) {
            return !!$templateCache.get(templateUrl);
        }

        function isBlockSichtbar(blockName, attrsArr) {
            return MiscUtilsService.isAtLeastOneTrue(attrsArr);

        }

        function editBlock(stepName, blockId) {
            if (vm.options.modalInstance) {
                vm.options.modalInstance.close();

                if (vm.options.modalInstance.result) {
                    vm.options.modalInstance.result.finally(function () {
                        $timeout(function () {
                            handleEditBlock(stepName, blockId);
                        }, 400);
                    });

                    return;
                }
            }

            handleEditBlock(stepName, blockId);
        }

        function handleEditBlock(stepName, blockId) {
            var currentStep = NavigationService.getActive().name;

            if (stepName === currentStep && blockId) {
                $timeout(function () {
                    HtmlUtilsService.scrollIntoView($window.document.getElementById(blockId), {
                        behavior: 'smooth',
                        block: 'start'
                    });
                });
                return;
            }

            if (NavigationService.isPrevious(stepName, currentStep)) {
                NavigationService.goToStep(stepName, {
                    reload: false
                }, null, null, null, function () {
                    $timeout(function () {
                        HtmlUtilsService.scrollIntoView($window.document.getElementById(blockId), {
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });
                });
            }
        }
        function getAngebotspartnerNameAsString(angebotspartner, properties, obj) {
            return AngebotUtilsService.getAngebotspartnerNameAsString(obj ? obj : vm.angebotModel.angebot, angebotspartner, properties);
        }

        function isAngebotAenderbar(type) {
            return BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, type);
        }
        function isTarifartAktiv(bausteinKey, tarifartWert) {
            return BasisAngebotService.isTarifartAktiv(vm.angebotModel.angebot, bausteinKey, tarifartWert);
        }

        function getAvbVersion(produktNr) {
            return BasisAngebotService.getAvbVersion(vm.angebotModel.angebot, produktNr);
        }

        function getArbeitgeberBerufFlags(partner, comparePartner) {
            if (BlockArbeitgeberBerufService) {
                return BlockArbeitgeberBerufService.getGuiFlags(partner, comparePartner);
            } else {
                return {};
            }
        }

        function isGevo(gevo) {
            return BasisAngebotService.isGevo(vm.angebotModel.angebot, gevo);
        }

        function isAngebotspartnerPrivatPerson(angebotspartner) {
            return BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot, angebotspartner);
        }
    }

})();
